// extracted by mini-css-extract-plugin
module.exports = {"switchWrapper":"ToggleSwitch_switchWrapper__n9vYL","switchThumb":"ToggleSwitch_switchThumb__1DHXU","switchLabel":"ToggleSwitch_switchLabel__GOJ7x"};